export const BEAUTY_SPOTS_SET = "beautySpotsSet";
export const BEAUTY_SPOT_SET = "beautySpotSet";
export const BEAUTY_SPOTS_RESET = "beautySpotsReset";
export const BEAUTY_SPOT_RESET = "beautySpotReset";
export const BEAUTY_SPOTS_SET_PAGINATION = "beautySpotsSetPagination";
export const BEAUTY_SPOT_SET_LOGO = "beautySpotSetLogo";
export const BEAUTY_SPOT_RESET_LOGO = "beautySpotResetLogo";
export const BEAUTY_SPOT_SET_CATEGORIES = "beautySpotSetCategories"
export const SET_BEAUTY_SPOT_ACTIVE = "setBeautySpotActive"
export const SET_BEAUTY_SPOT_PAGINATION = "setBeautySpotPagination"